
<template>
  <VirtualList
    :list="list"
    :dataComponent="dataComponent"
    @getData="getData"
    :finished="finished"
  />
</template>

<script>
import Bus from "@/utils/bus";
import VirtualList from "@/components/VirtualList";
import dataComponent from "@/views/Order/Index/components/InSaleItem";
import { InSaleList, getInSaleDetail } from "@/api/order/inSale";
export default {
  components: { VirtualList },
  props: ["tabType"],
  data() {
    return {
      dataComponent,
      list: [],
      finished: false,
      pagination: {
        page: 0,
        size: 10,
      },
      updateNo: null,
    };
  },
  created() {
    Bus.$on("refreshDataInSale", (value) => {
      this.updateNo = value;
    });
    console.log("this.tabType", this.tabType);
  },
  methods: {
    getData() {
      console.log(999);
      const params = this.pagination;
      params.state = [null, "INITIAL", "PAID", "SHIPPED", "COMPLETED"][
        this.tabType
      ];
      InSaleList(params).then((res) => {
        res.data.content.map((item) => {
          this.converData(item);
        });
        this.list.push(...res.data.content);
        if (res.data.content.length < this.pagination.size) {
          this.finished = true;
        } else {
          this.pagination.page++;
        }
      });
    },
    checkUpdateNo() {
      if (this.updateNo) {
        this.refreshData(this.updateNo);
        this.updateNo = null;
      }
    },
    refreshData(id) {
      console.log(111111111);
      this.$store.dispatch("app/showLoading");
      getInSaleDetail(id)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          const i = this.list.findIndex((item) => item.id === res.data.id);
          this.$set(this.list, i, this.converData(res.data));
        })
        .catch((res) => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    // 整单退 -> 用 order; orderItem 为空对象
    // 拆单退 -> 用 orderItem
    converData(data) {
      data.orderItemTotal = data.items.reduce(
        (prev, cur) => Number(prev) + Number(cur.qty),
        0
      );
      return data;
    },
  },
};
</script>

<style>
</style>